<template>
    <el-popover
        placement="left-start"
        width="350"
        title="Weitere Informationen"
        :visible-arrow="false"
        popper-class="smr-popper smr-popper--map-info"
        trigger="click"
        v-model="popperOpen"
        @show="popperShowHandler"
        @hide="popperHideHandler"
    >
        <div class="smr-popper__close" @click="popperCloseClickHandler">
            <icon><IconClose/></icon>
        </div>
        <div class="action-list">
            <component 
                :is="action.href ? 'a' : 'div'" 
                class="action-list__item ui-spread-center-vertically" 
                v-for="action in actions" :key="action.id" 
                @click="actionClickHandler(action)" 
                :href="action.href ? action.href : false" 
                :target="action.href ? '_blank' : false"
            >
                <span class="action-list__item__label copy black">{{ action.label }}</span>
                <icon class="action-list__item__arrow" :size="20">
                    <iconChevronRight />
                </icon>
            </component>
        </div>
        <div class="map__controls__item" slot="reference">
            <icon>
                <iconInfo />
            </icon>
        </div>
    </el-popover>
</template>

<script>
import { mapGetters } from 'vuex';
import eventBus from '@/utils/event-bus';
import Icon from '@/components/Icon.vue'
import IconClose from '@/components/icons/IconClose.vue'
import IconInfo from '@/components/icons/IconInfo.vue';
import IconChevronRight from '@/components/icons/IconChevronRight.vue';
import { trackEvent, trackGa4Event } from '@/utils/tracking'

export default {
    components: {
        Icon,
        IconClose,
        IconInfo,
        IconChevronRight
    },
    data() {
        return {
            popperOpen: false,
            actions: [
                {
                    id: 'feature-intro',
                    label: 'Neues im ÖAMTC Routenplaner',
                    trackingLabel: 'New Features',
                },
                {
                    id: 'faq',
                    label: 'Zu den FAQs',
                    href: 'https://www.oeamtc.at/thema/reiseplanung/routenplaner-tipps-und-infos-18194576',
                    trackingLabel: 'FAQs',
                },
                {
                    id: 'feedback',
                    label: 'Feedback geben',
                    href: 'https://www.oeamtc.at/ewa/forms/form/iz_gisportal_feedback',
                    trackingLabel: 'Open Feedback Menu',
                },
                // {
                //     id: 'legend',
                //     label: 'Legende'
                // },
                {
                    id: 'gas-station-disclaimer',
                    label: 'Haftungsausschluss Tankstellen',
                    trackingLabel: 'Disclaimer Gas Stations',
                },
                {
                    id: 'partner',
                    label: 'Kooperationspartner',
                    href: 'https://www.oeamtc.at/thema/reiseplanung/unsere-kooperationspartner-44505147',
                    trackingLabel: 'Partners',
                },
                {
                    id: 'privacy',
                    label: 'Datenschutz',
                    href: 'https://www.oeamtc.at/kontakt/datenschutzerklaerung-24518429#online-services-25167244',
                    trackingLabel: 'Data Privacy',
                },
                {
                    id: 'impressum',
                    label: 'Impressum',
                    href: 'https://www.oeamtc.at/mitgliedschaft/impressum-offenlegung-und-ecg-information-16182254',
                    trackingLabel: 'Imprint',
                },
            ]
        }
    },
    computed: {
        ...mapGetters(['mobile']),
    },
    methods: {
        actionClickHandler(action) {
            trackEvent({ category: 'Route Planner', action: 'Info', label: action.trackingLabel })

            const ga4TrackingLabel = action.trackingLabel.replace(/ /g, "_").toLowerCase();
            trackGa4Event({ga4Parameter1Name: 'options', ga4Parameter1Value: ga4TrackingLabel, ga4Event: 'route_planner_info'})
            
            if(action.href) return false;
            this.popperOpen = false;
            if(action.id === 'gas-station-disclaimer') {
                eventBus.$emit('showDisclaimerInfo', { storeData: false })
            }
            if(action.id === 'feature-intro') {
                eventBus.$emit('showFeatureIntroduction')
            }
        },
        popperShowHandler() {
            if(this.mobile) {
                this.$store.commit('setDim', true)
            }
        },
        popperHideHandler() {
            if(this.mobile) {
                this.$store.commit('setDim', false)
            }
        },
        popperCloseClickHandler() {
            this.popperOpen = false;
        },
    }
}
</script>

<style lang="scss">

</style>